import { todayTimeline } from '@/mocks/guatian';

const catDot: Record<string, string> = {
  影视: 'bg-primary-400',
  综艺: 'bg-secondary-400',
  音乐: 'bg-accent-400',
  商业: 'bg-background-400',
  趣闻: 'bg-accent-500',
};

const catIcon: Record<string, string> = {
  影视: 'ri-film-line',
  综艺: 'ri-mic-line',
  音乐: 'ri-music-2-line',
  商业: 'ri-store-2-line',
  趣闻: 'ri-emotion-laugh-line',
};

export default function TodayTimeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* 左：时间轴 */}
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-secondary-200 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-timer-flash-line" aria-hidden="true" /> 今日速递
            </p>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">大瓜盘点时间轴</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从清晨到午后，今日的重点动态都给你按时间捋好了。错过直播？这里帮你一键补课当天全部新瓜。
            </p>

            <ol className="mt-8 space-y-0">
              {todayTimeline.map((t, i) => (
                <li key={i} className="relative flex gap-4 pb-6 last:pb-0">
                  <div className="flex flex-col items-center">
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${catDot[t.type] || 'bg-background-300'} text-white`}>
                      <i className={`${catIcon[t.type] || 'ri-sparkling-2-line'} text-sm`} aria-hidden="true" />
                    </span>
                    {i < todayTimeline.length - 1 && (
                      <span className="mt-1 w-px flex-1 bg-background-200" aria-hidden="true" />
                    )}
                  </div>
                  <div className="pb-1">
                    <span className="font-heading text-lg text-primary-600">{t.time}</span>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-800 md:text-[15px]">{t.event}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* 右：本周热议亮点 */}
          <aside className="flex flex-col">
            <div className="mb-5 flex items-center gap-2 text-sm font-medium text-foreground-800">
              <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-accent-500 text-accent-950">
                <i className="ri-bar-chart-2-line" aria-hidden="true" />
              </span>
              本周热议亮点 · 持续发酵中
            </div>
            <div className="flex flex-1 flex-col gap-4">
              {[
                { icon: 'ri-focus-3-line', t: '谁的回归最让人意外？', d: '多位久未营业的艺人本周密集官宣行程，网友直呼"童年回来了"，相关回忆杀内容播放量持续走高。', color: 'text-primary-600 bg-primary-100' },
                { icon: 'ri-speaker-3-line', t: '真人秀"剧本论"再起波澜', d: '一档新综因剪辑片段被扒出疑似"剧情走向提前泄露"，节目组紧急回应澄清，评论区站成两派吵得不可开交。', color: 'text-accent-600 bg-accent-100' },
                { icon: 'ri-megaphone-line', t: '代言风向大转弯', d: '从运动潮牌到高端美妆，本周官宣的品牌合作横跨多个赛道，"人设与调性匹配度"成为粉丝最在意的新标准。', color: 'text-secondary-700 bg-secondary-200' },
              ].map((c, i) => (
                <div key={i} className="flex gap-4 rounded-3xl border border-background-200 bg-background-100/70 p-5">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${c.color}`}>
                    <i className={`${c.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-[15px] font-semibold text-foreground-950">{c.t}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}